import { ATTACHMENT } from './attachmentActions';
import { PsRoutes } from '../shared/routing/Routes';
import {
    DOCUMENT_REVISION_BATCH_FAILED,
    DOCUMENT_REVISION_BATCH_LOADING,
    DOCUMENT_REVISION_BATCH_SUCCEED,
} from '../documents/actions/documentRevisionsActions';
import { DocumentUtils } from '../shared/utils/DocumentUtils';

const INITIAL_STATE = {
    files: {},
    documents: {},
    backPathname: PsRoutes.HOME,
    revisionLoading: false,
};

export default (state = INITIAL_STATE, action) => {
    switch ( action.type ) {
        case ATTACHMENT.CLEAR:
            return {
                ...INITIAL_STATE,
            };
        case ATTACHMENT.SET_BACK_PATHNAME:
            return {
                ...state,
                backPathname: action.payload,
            };
        case DOCUMENT_REVISION_BATCH_LOADING:
            return {
                ...state,
                revisionLoading: action.payload,
            };
        case DOCUMENT_REVISION_BATCH_SUCCEED:
            return setRevisions(state, action.payload);
        case DOCUMENT_REVISION_BATCH_FAILED:
            return state;
        case ATTACHMENT.SET_FILES:
            return setFiles(state, action.payload);
        case ATTACHMENT.ADD_REMOVE:
            return addRemove(state, action.payload);
        case ATTACHMENT.ADD_ALL:
            return addAll(state, action.payload);
        case ATTACHMENT.REMOVE_ALL:
            return removeAll(state, action.payload);
        default:
            return state;
    }
};

const setFiles = (prevState, files) => {
    const nextState = { ...prevState };
    const filesDic = {};
    for ( const file of files ) filesDic[file.uuid] = { ...file };
    nextState.files = filesDic;
    return nextState;
};

const setRevisions = (prevState, docRevs) => {
    const nextState = { ...prevState };

    for ( const docRev of docRevs ) {
        const revisions = { ...docRev };
        delete revisions['document_id'];
        const nextDocument = nextState.documents[docRev.document_id];
        nextState.documents[docRev.document_id] = { ...nextDocument, revisions };
    }

    return nextState;
};

const addRemove = (prevState, doc) => {
    const nextState = { ...prevState };
    const docDic = { ...prevState.documents };
    const docIds = Object.keys(prevState.documents);
    const included = docIds.includes(String(doc.id));
    if ( included ) delete docDic[doc.id];
    else docDic[doc.id] = parseDocument(doc);
    nextState.documents = docDic;
    return nextState;
};

const addAll = (prevState, docs) => {
    const nextState = { ...prevState };
    const docDic = { ...prevState.documents };
    const docIds = Object.keys(prevState.documents);
    for ( const doc of docs ) {
        const notIncluded = !docIds.includes(doc.id);
        if ( notIncluded ) docDic[doc.id] = parseDocument(doc);
    }
    nextState.documents = docDic;
    return nextState;
};

const removeAll = (prevState, docs) => {
    const nextState = { ...prevState };
    const docDic = { ...prevState.documents };
    for ( const doc of docs ) delete docDic[doc.id];
    nextState.documents = docDic;
    return nextState;
};

const parseDocument = (doc) => ( {
    id: doc.id,
    name: DocumentUtils.getDocumentName(doc),
    expires: doc.document_type.expires,
    extensions: doc.document_type.extensions,
    mimeTypes: doc.document_type.mime_types,
    revisions: {},
} );



// WEBPACK FOOTER //
// ./src/app/attachment/AttachmentReducer.js